export function getMinuteStyleByState(minuteState: string): unknown {
    let color: string = '';
    switch(minuteState) {
      case 'Pendiente':
        color ='purple';
        break;
      case 'Cancelada':
        color = 'orange';
        break;
      case 'Rechazado':
        color = 'red';
        break;
      case 'Aprobado':
        color = 'green';
        break;
      case 'Pre-Aprobado':
        color = 'orange';
        break;
      case 'En Borrador':
        color = 'gray';
        break;
      case 'En Comité':
        color = 'blue';
        break;
      default:
        color = 'black';
        break;
    }

    return {
      'color': color
    };
}